import { render, staticRenderFns } from "./stakeholder-dialog.vue?vue&type=template&id=91049dca"
import script from "./stakeholder-dialog.ts?vue&type=script&lang=js&external"
export * from "./stakeholder-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports